import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Card = styled(Box)(() => ({
  position: 'relative',
  backgroundColor: protoColors.surface,
  border: `1px solid ${protoColors.border}`,
  borderRadius: '14px',
  padding: '18px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  minHeight: '104px',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    backgroundColor: protoColors.purple,
  },
}));

export const Label = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 600,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: protoColors.textMuted,
}));

export const Value = styled(Typography)(() => ({
  fontSize: '30px',
  lineHeight: 1.1,
  fontWeight: 700,
  color: protoColors.textPrimary,
}));

export const Hint = styled(Typography)(() => ({
  fontSize: '13px',
  color: protoColors.textMuted,
}));
